module.exports = __webpack_public_path__ + "static/domain-whois_1-e3ab3241631f49dcd1b3fb703a9146e0.jpg";